export default __webpack_public_path__ + "static/media/me12.c7c1a5f7.gif";